import { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import classes from "./Nav.module.css";

const Nav = (props) => {
  let navClasses = "links " + classes.links;

  const location = useLocation();
  let isExport = location.pathname.includes("export");

  const [isScreenWidthSmall, setIsScreenWidthSmall] = useState(
    window.innerWidth < 768
  );

  useEffect(() => {
    const handleResize = () => {
      setIsScreenWidthSmall(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <header id="header" className={classes.header}>
      <h1>
        <span className={classes.a}>A</span>
        <span className={classes.p}>P</span>
        <span className={classes.i}>i</span>
        <span className={classes.e}>
          <em>E</em>
        </span>
      </h1>
      <nav className={navClasses}>
        <ul>
          {!props.isAdminMode && (
            <>
              <li>
                <NavLink to="/accueil" className={classes.navlink}>
                  Accueil
                </NavLink>
              </li>
              <li>
                <NavLink to="/faire-une-demande" className={classes.navlink}>
                  Transmettre une demande
                </NavLink>
              </li>
              <li>
                <NavLink to="/mes-demandes" className={classes.navlink}>
                  Mes demandes
                </NavLink>
              </li>
            </>
          )}
          {props.isAdmin &&
            (!props.isAdminMode || isExport) &&
            !isScreenWidthSmall && (
              <li>
                <NavLink
                  to="/admin"
                  onClick={() => {
                    props.switchMode("admin");
                  }}
                  className={classes.navlink}
                >
                  Administration
                </NavLink>
              </li>
            )}
          {props.isAdmin && props.isAdminMode && (
            <>
              <li>
                <NavLink
                  to="/accueil"
                  onClick={() => {
                    props.switchMode("user");
                  }}
                  className={classes.navlink}
                >
                  Vue utilisateur
                </NavLink>
              </li>
              <li>
                <NavLink to="/admin/export" className={classes.navlink}>
                  Exporter les données
                </NavLink>
              </li>
            </>
          )}
        </ul>
      </nav>
    </header>
  );
};

export default Nav;
